<div class="picker">
  <div class="group-card" *ngFor="let g of groups">
    <label class="group-label">
      Select the <span>{{ g.group }}</span> target platform:
    </label>

    <mat-button-toggle-group
      class="targets-grid"
      [value]="selectedId"
      (change)="onGroupChange($event)"
      [style.--cols]="buttonsPerRow"
      [style.--gap.px]="12">

      <mat-button-toggle
        class="target-toggle"
        *ngFor="let tp of g.items; trackBy: trackById"
        [value]="tp.id"
        [title]="tp.name">
        <span class="toggle-content">
          <img [src]="getTransferFileIcon(tp)" [alt]="tp.name" width="32" height="32">
          <span class="target-name">{{ tp.name }}</span>
        </span>
      </mat-button-toggle>

    </mat-button-toggle-group>
  </div>
</div>
